module.exports = __webpack_public_path__ + "fa-brands-400.ttf?6a004ddb259f02543b250c8467669ea6";